module.exports = __webpack_public_path__ + "static/media/imagedark.19f0afb4.svg";